import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { FiBook, FiLock, FiUser, FiArrowRight } from 'react-icons/fi';
import Button from '../../components/Button/Button';
import './Login.css';

// Using the generated premium image
import loginBg from '../../assets/images/library_login_bg.png';

const Login = () => {
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!username || !password) {
      setError('Credentials required.');
      return;
    }

    setLoading(true);
    setError('');

    const res = await login(username, password);
    if (!res.success) {
      setError(res.error || 'Invalid credentials.');
      setLoading(false);
    }
  };

  return (
    <div className="premium-login-page">
      <div className="login-container-split">

        {/* Left Side: Dynamic Visual Section */}
        <div className="login-visual-section">
          <div className="visual-overlay"></div>
          <img src={loginBg} alt="Library Management System" className="visual-image" />

          <div className="visual-content">
            <div className="luxury-logo">
              <div className="logo-icon-box">
                <FiBook />
              </div>
              <span className="logo-text">Dr. SS Johl <span>Library</span></span>
            </div>

            <div className="visual-footer">
              <h1>Redefining Knowledge Management</h1>
              <p>Experience the most advanced, secure, and intelligent library ecosystem built for modern librarians.</p>
              <div className="visual-badges">
                <span className="v-badge">v2.0 Pro</span>
                {/* <span className="v-badge">SQL Cluster</span> */}
                <span className="v-badge">Leo AI Enabled</span>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side: Professional Form Section */}
        <div className="login-form-section">
          <div className="form-inner-wrapper">
            <div className="form-header">
              <h2>Welcome Back</h2>
              <p>Please enter your professional credentials to access the library dashboard.</p>
            </div>

            {error && (
              <div className="login-error-toast animate-shake">
                <FiInfo className="error-icon" />
                <span>{error}</span>
              </div>
            )}

            <form onSubmit={handleLogin} className="premium-form">
              <div className="p-input-group">
                <label>Username</label>
                <div className="p-input-field">
                  <FiUser className="p-icon" />
                  <input
                    type="text"
                    placeholder="Enter username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    autoFocus
                  />
                </div>
              </div>

              <div className="p-input-group">
                <label>Password</label>
                <div className="p-input-field">
                  <FiLock className="p-icon" />
                  <input
                    type="password"
                    placeholder="Enter password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
              </div>

              <div className="form-action-btn">
                <Button
                  type="submit"
                  variant="primary"
                  fullWidth
                  loading={loading}
                  icon={<FiArrowRight />}
                >
                  Authenticate
                </Button>
              </div>
            </form>

            <div className="login-legal">
              <p>© {new Date().getFullYear()} WhizInfo Technologies</p>
              {/* <span>Enterprise Edition</span> */}
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

// Internal icon for error
const FiInfo = ({ className }) => (
  <svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="12" y1="16" x2="12" y2="12"></line>
    <line x1="12" y1="8" x2="12.01" y2="8"></line>
  </svg>
);

export default Login;
